/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormElementSectionSnapshotDto } from './FormElementSectionSnapshotDto';
import {
    FormElementSectionSnapshotDtoFromJSON,
    FormElementSectionSnapshotDtoFromJSONTyped,
    FormElementSectionSnapshotDtoToJSON,
    FormElementSectionSnapshotDtoToJSONTyped,
} from './FormElementSectionSnapshotDto';
import type { ApplicationFormStatus } from './ApplicationFormStatus';
import {
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusFromJSONTyped,
    ApplicationFormStatusToJSON,
    ApplicationFormStatusToJSONTyped,
} from './ApplicationFormStatus';

/**
 * 
 * @export
 * @interface ApplicationFormSnapshotDto
 */
export interface ApplicationFormSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormSnapshotDto
     */
    name: string;
    /**
     * 
     * @type {ApplicationFormStatus}
     * @memberof ApplicationFormSnapshotDto
     */
    status: ApplicationFormStatus;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormSnapshotDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormSnapshotDto
     */
    organizationName?: string | null;
    /**
     * 
     * @type {Array<FormElementSectionSnapshotDto>}
     * @memberof ApplicationFormSnapshotDto
     */
    sections: Array<FormElementSectionSnapshotDto>;
}



/**
 * Check if a given object implements the ApplicationFormSnapshotDto interface.
 */
export function instanceOfApplicationFormSnapshotDto(value: object): value is ApplicationFormSnapshotDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function ApplicationFormSnapshotDtoFromJSON(json: any): ApplicationFormSnapshotDto {
    return ApplicationFormSnapshotDtoFromJSONTyped(json, false);
}

export function ApplicationFormSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': ApplicationFormStatusFromJSON(json['status']),
        'organizationId': json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'sections': ((json['sections'] as Array<any>).map(FormElementSectionSnapshotDtoFromJSON)),
    };
}

export function ApplicationFormSnapshotDtoToJSON(json: any): ApplicationFormSnapshotDto {
    return ApplicationFormSnapshotDtoToJSONTyped(json, false);
}

export function ApplicationFormSnapshotDtoToJSONTyped(value?: ApplicationFormSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': ApplicationFormStatusToJSON(value['status']),
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'sections': ((value['sections'] as Array<any>).map(FormElementSectionSnapshotDtoToJSON)),
    };
}

